export default __webpack_public_path__ + "static/media/facebook_call.6b6b5b4d.mp3";